import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-6d013f3f.mjs';
import './MatchMediaMixin-cd993bd3.mjs';
import { s as script } from './Field-ba437ae1.mjs';
export { s as OField } from './Field-ba437ae1.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
